import React, { FC, FormEventHandler } from 'react';
import styled from 'styled-components/macro';
import Column from './Column';
import BlockButton from './BlockButton';
import Select from './Select';
import Form from './Form';

interface Props {
  value?: string | number;
  onChange?: FormEventHandler<HTMLSelectElement>;
  onSubmit?: FormEventHandler<HTMLFormElement>;
}

const SiteSelectForm: FC<Props> = props => {
  const { value, onChange, onSubmit, ...rest } = props;

  return (
    <Column {...rest}>
      <Form onSubmit={onSubmit}>
        <Title>Select Site</Title>
        <SiteSelect
          value={value}
          onChange={onChange}
          placeholder="Choose Site"
        >
          {props.children}
        </SiteSelect>
        <SubmitButton disabled={!value || value === ''}>Go</SubmitButton>
      </Form>
    </Column>
  );
};

export default styled(SiteSelectForm)`
  width: 352px;
  max-width: 100%;

  > ${Form} {
    align-items: center;
  }
`;

const Title = styled('h1')`
  color: white;
  font-size: 56px;
  line-height: 64px;
  margin: 0 0 32px 0;
  text-align: center;
  width: 100%;
`;

const SiteSelect = styled(Select as any)`
  width: 100%;
  margin-bottom: 32px;
`;

const SubmitButton = styled(BlockButton as any)`
  width: 159px;
`;
